export default function MenuClose() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="14.1426"
        width="20"
        height="1"
        transform="rotate(-45 0 14.1426)"
        fill="#593B37"
      />
      <rect
        width="20"
        height="1"
        transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 15 14.1426)"
        fill="#593B37"
      />
    </svg>
  );
}
